import { server } from "../utils/server";

const getListingTeaser = (userId) => {
    return server.get(`listingTeaserInvestorPlatform/?userId=${userId}`)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

const setInterestedTeasers = (data)=>{
    return server.post("listingTeaserInvestorPlatform/setIntrestedInvestor", data)
    .then((res)=>{
        return res.data;
    })
    .catch((err)=>{
        console.log(err);
    });
}

export default {
    getListingTeaser,
    setInterestedTeasers,
}
